import React from 'react';
import { Typography } from 'fronton-react';

import { CardDescription } from './styles';

export type CardInfoProps = {
	name: string;
	description: string;
	isPopularCard: boolean;
	isOrderCard: boolean;
	isSmallScreen: boolean;
};

export const CardInfo = ({
	name,
	description,
	isPopularCard,
	isOrderCard,
	isSmallScreen,
}: CardInfoProps) => {
	const textSize = isSmallScreen ? 's' : 'm';
	const cardInfoTextDataQa = isSmallScreen ? 'card-info-text--small' : 'card-info-text--large';

	let children;

	/**
	 * для карточки из блока "Популярные услуги" (в регионах!) необходимо вывести название и описание категории
	 * для карточки из каталога или блока "Популярные услуги" (в Москве!) выводим только название
	 * для карточки с телефоном из каталога выводим только описание
	 */

	if (isPopularCard) {
		children = (
			<>
				<Typography variant="h3">{name}</Typography>
				<Typography variant="s" size="body_long" className={CardDescription}>
					{description}
				</Typography>
			</>
		);
	} else if (isOrderCard) {
		children = (
			<Typography variant={textSize} size="body_short" data-qa={cardInfoTextDataQa}>
				{name}
			</Typography>
		);
	} else {
		children = null;
	}

	return <div data-analyticsName="productTextLink">{children}</div>;
};
